import { Typography, Modal } from '../components/primitives';
import { Icons } from '../icons';
import { testId } from '../utils';
import { useTranslation } from '@rpi/i18n';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

interface RegisteredContextProps {
  children: React.ReactNode;
}

export const RegisteredModalContext: React.FC<RegisteredContextProps> = ({
  children,
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'route.registered_modal',
  });
  const [searchParams] = useSearchParams();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (searchParams.get('registered') === 'true') {
      setOpen(true);
    }
  }, [searchParams]);

  return (
    <>
      <Modal
        {...testId('registered-modal')}
        icon={<Icons.MarkEmailRead />}
        title={t('title')}
        contentElement={
          <Typography className="text-center" variant="body-large">
            {t('text')}
          </Typography>
        }
        open={open}
        setOpen={setOpen}
      />
      {children}
    </>
  );
};
